import { render, staticRenderFns } from "./ConfigTile.vue?vue&type=template&id=4232fdc0&scoped=true&"
import script from "./ConfigTile.vue?vue&type=script&lang=js&"
export * from "./ConfigTile.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTile.vue?vue&type=style&index=0&id=4232fdc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4232fdc0",
  null
  
)

export default component.exports